/**
 * Legacy read — map the old `{ preset, knobs }` theme (5 presets + 4 knobs) onto
 * `BrandInputs`, lazily, on load. This is NOT a migration: there is no server and
 * offline CRDT docs keep the old shape forever, so reads must tolerate it
 * indefinitely. New sites store `BrandInputs` directly.
 */
import type { BrandInputs } from "./brand.js";
import { CURATED_THEMES } from "./themes.js";

export type LegacyPreset =
  | "minimal"
  | "bold"
  | "editorial"
  | "creative"
  | "corporate";

export interface LegacyKnobs {
  readonly primaryColor?: string;
  readonly accentColor?: string;
  readonly bodyFont?: string;
  readonly headingFont?: string;
}

// The five legacy presets share the curated themes' vibes 1:1 (same ids), so the
// curated themes are the single source of truth for both.
const PRESETS = Object.fromEntries(
  CURATED_THEMES.map((t) => [t.id, t.brand]),
) as Record<LegacyPreset, BrandInputs>;

export function fromLegacy(
  preset: LegacyPreset,
  knobs: LegacyKnobs = {},
): BrandInputs {
  const p = PRESETS[preset] ?? PRESETS.minimal;
  return {
    brandColor: knobs.primaryColor ?? p.brandColor,
    accentColor: knobs.accentColor ?? p.accentColor,
    headingFont: knobs.headingFont ?? p.headingFont,
    bodyFont: knobs.bodyFont ?? p.bodyFont,
    cornerRoundness: p.cornerRoundness,
    density: p.density,
  };
}
